export default function getChicagoTime() {
	const date = new Date();

	// Отримаємо час в часовому поясі Чикаго
	const chicagoTime = new Intl.DateTimeFormat('en-US', {
		timeZone: 'America/Chicago',
		hour: '2-digit',
		minute: '2-digit',
		hour12: false, // Щоб було в 24-годинному форматі
	}).format(date);

	return chicagoTime;
}
